<template>
  <div>
    <v-data-iterator
      :items="cashBook"
      class="profit"
      content-tag="div"
      :content-class="'layout row wrap'"
      hide-actions >
      <template slot="header">
        <v-toolbar class="mb" color="primary" dark  flat>
          <v-toolbar-title class="font-weight-light">Cash Book</v-toolbar-title>
          <v-spacer/>
            <v-btn icon dark @click="print()">
              <v-icon>print</v-icon>
            </v-btn>
          <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link>
        </v-toolbar>
        <v-toolbar class="mb" color="white white--text" flat>
          <v-layout row>
            <v-flex>
              <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
              ></v-autocomplete>
            </v-flex>
            <v-spacer/>
            <v-flex>
              <v-menu
                :close-on-content-click="false"
                v-model="datepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  clearable
                  v-model="selectedDate"
                  single-line
                  label="Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="selectedDate" @input="datepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      </template>

      <template slot="item" slot-scope="props">
        <v-flex  style=" display: flex;flex-direction: column;" xs6 md6 sm6 v-if="props.item.expense">
          <v-card>
            <v-card-title class="primary white--text">
              <h3><span class="print-field">Particulars</span></h3>
              <v-spacer/><span class="print-field">Amount</span>
            </v-card-title>
          </v-card>
          
          <v-card>
            <v-card-title>
              <h3><span class="print-field">Opening Balance</span></h3>
              <v-spacer />
              <h3 v-if="selectedFirm"><span class="print-field">{{getClosingAmount || 0 | amount }}</span></h3>
            </v-card-title>
          </v-card>

          <expand-card
            :hasItems="cashSale.invoice.length > 0"
            :value="cashSale.total || 0 | amount"
          >  
            <template slot="header"> 
              <b><span class="print-field">Cash Sale</span></b>
            </template>
            
            <template slot="items">
              <template v-for="(cash, c) in cashSale.invoice" >
                <v-expansion-panel-content 
                  v-bind:key="c"
                >
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <h3 class="primary--text font-weight-bold"><span class="print-field">{{ cash.userName }}</span></h3> 
                        <v-spacer />
                        <h3 class="primary--text font-weight-bold"><span class="print-field">{{ cash.amount || 0 | amount  }}</span></h3>
                      </v-card-title>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
              </template>
            </template>  
          </expand-card>

          <expand-card
            :hasItems="receipts.invoice.length > 0"
            :value="receipts.total || 0 | amount"
          >  
            <template slot="header"> 
              <b><span class="print-field">Receipts</span></b>
            </template>
            
            <template slot="items">
              <template v-for="(receipt, r) in receipts.invoice" >
                <v-expansion-panel-content 
                  v-bind:key="r"
                >
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <h3 class="primary--text font-weight-bold"><span class="print-field">{{ receipt.userName }}</span></h3> 
                        <v-spacer />
                        <h3 class="primary--text font-weight-bold"><span class="print-field">{{ receipt.amount || 0 | amount  }}</span></h3>
                      </v-card-title>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
              </template>
            </template>  
          </expand-card>

          
          <!-- total right side -->
          <v-card style="margin-top: auto;">
            <v-card-title class="primary white--text">
              <h3><span class="print-field">Total</span></h3>
              <v-spacer />
              <h3><span class="print-field">{{Number.parseFloat(receipts.total) + Number.parseFloat(cashSale.total) + 
                 Number.parseFloat(getClosingAmount) | amount}}</span></h3>
            </v-card-title>
          </v-card>
        
        </v-flex>
        <v-flex  style=" display: flex;flex-direction: column;" xs6 md6 sm6 v-if="!props.item.expense">
          <v-card>
            <v-card-title class="primary white--text">
              <h3><span class="print-field">Particulars</span></h3>
              <v-spacer/><span class="print-field"> Amount </span>
            </v-card-title>
          </v-card>

          <!-- Total Expense --> 
         <expand-card
            :hasItems="expenses.invoice.length > 0"
            :value="expenses.total || 0 | amount"
          >  
            <template slot="header"> 
              <b><span class="print-field">Expenses</span></b>
            </template>
            
            <template slot="items">
              <template v-for="(exp, ex) in expenses.invoice" >
                <v-expansion-panel-content 
                  v-bind:key="ex"
                >
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <h3 class="primary--text font-weight-bold"><span class="print-field">{{ exp.name }}</span></h3> 
                        <v-spacer />
                        <h3 class="primary--text font-weight-bold"><span class="print-field">{{ exp.amount || 0 | amount  }}</span></h3>
                      </v-card-title>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
              </template>
            </template>  
          </expand-card>
        
        <!-- Total Payments --> 
          <expand-card
            :hasItems="payments.invoice.length > 0"
            :value="payments.total || 0 | amount"
          >  
            <template slot="header"> 
              <b><span class="print-field">Payments</span></b>
            </template>
            
            <template slot="items">
              <template v-for="(pay, p) in payments.invoice" >
                <v-expansion-panel-content 
                  v-bind:key="p"
                >
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <h3 class="primary--text font-weight-bold"><span class="print-field">{{ pay.userName }}</span></h3> 
                        <v-spacer />
                        <h3 class="primary--text font-weight-bold"><span class="print-field">{{ pay.amount || 0 | amount  }}</span></h3>
                      </v-card-title>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
              </template>
            </template>  
          </expand-card>

        <!-- Closing Balance -->
          <v-card>
            <v-card-title>
              <h3><span class="print-field">Closing Balance</span></h3>
              <v-spacer />
              <h3><span class="print-field">{{getClosingAmountOfDay || 0 | amount }}</span></h3>
            </v-card-title>
          </v-card>
          <v-card style="margin-top: auto;">
            <v-card-title class="primary white--text">
              <h3><span class="print-field">Total</span></h3>
              <v-spacer />
              <h3><span class="print-field">{{Number.parseFloat(getClosingAmountOfDay) + Number.parseFloat(payments.total) + Number.parseFloat(expenses.total) || 0 | amount}}</span></h3>
            </v-card-title>
          </v-card>
        </v-flex>
      </template>
    </v-data-iterator>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import ExpandCard from '../Balancesheet/expandCard';
import {convertToCashBook } from "../../../utils/pdf-reports/information-reports";
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

  export default {
    components: {
      ExpandCard,
    },
    data: () => ({
       cashBook: [
        {
          expense: true
        },
        {
          expense: false
        }
      ],
      firmClosingAmount : 0,
      datepicker:null,
      selectedDate:new Date().toISOString().substr(0, 10),
      selectedFirm : null,
      firmCashSale : 0,
      firmReceipt: 0,
      firmPayment : 0,
      firmExpense : 0,
      expenses : {
        total : 0,
        invoice : []
      },
      cashSale : {
        total : 0,
        invoice : []
      },
      receipts :  {
        total : 0,
        invoice : []
      },
      payments :  {
        total : 0,
        invoice : []
      },
    }),
    created() {
      this.$bindAsArray('invoiceHistory', this.$root.$firebaseRefs.invoiceHistory.orderByChild('brandFinYear').equalTo(this.brandFinYear))
      this.$bindAsArray('invoice', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear))
      this.$bindAsObject('expense', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('firm', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray ("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand))
    },
    computed: {
      ...mapGlobalGetters(['selectedBrand','finYear']),
      firmsByBrand () {
        // return selected brand firms
        let firms = this.firm
          .filter((item) => item['brand'] === this.selectedBrand)
          firms.map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
            }
          })
          return firms;
      },
      getClosingAmount(){
        return ((Number.parseFloat(this.firmClosingAmount) + Number.parseFloat(this.firmCashSale) + Number.parseFloat(this.firmReceipt))
        -(Number.parseFloat(this.firmExpense) + Number.parseFloat(this.firmPayment)))
      },
      getClosingAmountOfDay(){
        return ((Number.parseFloat(this.getClosingAmount) + Number.parseFloat(this.cashSale.total) + Number.parseFloat(this.receipts.total))
        -(Number.parseFloat(this.expenses.total) + Number.parseFloat(this.payments.total)))
      },
    },
    watch:{
      selectedDate(nval, oval) {
        if (oval !== nval) {
        this.getData();
        }
      },
      selectedFirm: {
        handler(newVal, oldVal) {
          this.firmClosingAmount = newVal.openingCashAmount || 0;
          this.getData();
        },
        deep: true
      },
       selectedBrand(nval, oval) {
        if (oval !== nval) {
        this.getData();
        }
      },
    },
    methods:{
      print(){
        let data = [];
        $(".print-field").each(function( index ) {
          data.push($( this ).text())
        });
        let doc = convertToCashBook({data});
        pdfMake.createPdf(doc).download();
      },
      resetData(){
        this.cashSale = {
          total : 0,
          invoice : []
        };
        this.receipts = {
          total : 0,
          invoice : []
        };
        this.payments = {
          total : 0,
          invoice : []
        }
        this.expenses = {
          total : 0,
          invoice : []
        }
        this.firmCashSale = 0;
        this.firmReceipt= 0;
        this.firmPayment = 0;
        this.firmExpense = 0;
      },
      getCustomerName(buyerId,isBuyer){
        if(isBuyer) {
          let buyer = this.buyerById[buyerId];
          return buyer ? buyer.name : "";
        } else {
          let seller = this.sellerById[buyerId];
          return seller ? seller.name : "";
        }
      },
      isDateEqual(dt1,dt2){
         let date1 = JSON.parse(JSON.stringify(dt1));
        let date2 = JSON.parse(JSON.stringify(dt2));
        let dateA = new Date(date1).setHours(0,0,0,0);
        let dateB = new Date(date2).setHours(0,0,0,0);
        return (dateA == dateB);
      },
      expenseNameById (id) {
          if(this.expense[id]){
              return this.expense[id]['expense']
          }
      },
      getData(){
        this.resetData();
        let self = this;
        let  selectedDateString = new Date(this.selectedDate).getTime()
        let invoiceHistory  =  this.invoiceHistory.filter((item) => 
                (item['brand'] === this.selectedBrand && 
                ((this.selectedFirm) ? (item['firm'] === this.selectedFirm['.key']): true) && 
                (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
                (item.deleted != true) &&
                ((this.selectedFirm) ? (item['date'] >= new Date(this.selectedFirm['openingDate']).getTime()): false) && 
                (item.status == 'partial' || item.status == 'paid'))
        )
        let expenseInvoice = this.invoice.filter((item) => 
             (item['brand'] === this.selectedBrand && 
                ((this.selectedFirm) ? (item['firm'] === this.selectedFirm['.key']): true) && 
                (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
                ((this.selectedFirm) ? (item['date'] >= new Date(this.selectedFirm['openingDate']).getTime()): false) && 
                (item.type == 'automatic invoice' && item.expenseType && item.expenseType.length)
        ));
        let customerDeposit  = this.deposit.filter(
          item =>
            item["brand"] === this.selectedBrand &&
            ((this.selectedFirm) ? (item['firm'] === this.selectedFirm['.key']): true) && 
            (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
            ((this.selectedFirm) ? (item['date'] >= new Date(this.selectedFirm['openingDate']).getTime()): false) && 
            (item.settledAmount != undefined) && 
            (item.isBuyer != undefined) &&
            (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security")
          );

        customerDeposit.map((invoice)=>{
          if(invoice.isBuyer) {
            if(invoice.date < selectedDateString) {
              self.firmReceipt +=Number.parseFloat(isNaN(invoice.settledAmount) ? 0 : invoice.settledAmount);
            }
            if(self.isDateEqual(invoice.date,selectedDateString)) {
              self.receipts.invoice.push({
                userName: self.getCustomerName(invoice.buyerId,invoice.isBuyer),
                amount : invoice.settledAmount
              })
                self.receipts.total +=Number.parseFloat(invoice.settledAmount);
              }
            } else {
              if(invoice.date < selectedDateString) {
                self.firmPayment +=Number.parseFloat(isNaN(invoice.settledAmount) ? 0 : invoice.settledAmount);
              }
              if(self.isDateEqual(invoice.date,selectedDateString)) {
                self.payments.invoice.push({
                  userName: self.getCustomerName(invoice.buyerId,invoice.isBuyer),
                  amount : invoice.settledAmount
                })
                self.payments.total +=Number.parseFloat(invoice.settledAmount);
              }
            }
          })
          expenseInvoice.map((invoice)=>{
            if(invoice.date < selectedDateString) {
              self.firmExpense +=Number.parseFloat(isNaN(invoice.totalAmount) ? 0 : invoice.totalAmount);
            }
            if(this.isDateEqual(invoice.date,selectedDateString)) {
              this.expenses.invoice.push({
                name: this.expenseNameById(invoice.expenseType),
                amount : invoice.totalAmount
              })
              self.expenses.total +=Number.parseFloat(invoice.totalAmount);
            }
          })
        invoiceHistory = _.groupBy(invoiceHistory, 'parentInvoiceKey')
        _.each(invoiceHistory, (value, key, obj)=> {
          if(obj[key].length > 1) {
          let invoicesSorted = obj[key].sort(function(a,b){
            return -(new Date(b.date) - new Date(a.date));
          });

          const diffTime =  new Date(invoicesSorted[invoicesSorted.length-1].date).getTime() - new Date(invoicesSorted[0].date).getTime()
          const diffDays = diffTime / (1000 * 3600 * 24); 
            if(diffDays >= 1) {
              invoicesSorted.map((inv)=>{
                 if(inv.isBuyer) {
                    if(inv.date < selectedDateString) {
                      self.firmReceipt +=(Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']));
                    }
                    if(this.isDateEqual(inv.date,selectedDateString)) {
                      self.receipts.invoice.push({
                        userName : self.getCustomerName(inv.buyerId,inv.isBuyer),
                        amount : (Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']))
                      })
                      self.receipts.total +=(Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']));
                    }
                  } else {
                    if(inv.date < selectedDateString) {
                      self.firmPayment +=(Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']));
                    }
                    if(this.isDateEqual(inv.date,selectedDateString)) {
                      self.payments.invoice.push({
                        userName : self.getCustomerName(inv.buyerId,inv.isBuyer),
                        amount : (Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']))
                      })
                      self.payments.total +=(Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']));
                    }
                  }
              })
            } else {
              invoicesSorted.map((inv)=>{
                 if(inv.isBuyer) {
                   if(inv.date < selectedDateString) {
                      self.firmCashSale +=(Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']));
                    }
                    if(this.isDateEqual(inv.date,selectedDateString)) {
                      self.cashSale.invoice.push({
                        userName : self.getCustomerName(inv.buyerId,inv.isBuyer),
                        amount : (Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']))
                      })
                      self.cashSale.total +=(Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']));
                    }
                  } else {
                    if(this.isDateEqual(inv.date,selectedDateString)) {
                      if(inv.date < selectedDateString) {
                        self.firmPayment +=(Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']));
                      }
                      self.payments.invoice.push({
                        userName : self.getCustomerName(inv.buyerId,inv.isBuyer),
                        amount : (Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']))
                      })
                      self.payments.total +=(Number.parseFloat(inv['amountFromBank']) + Number.parseFloat(inv['amountFromCash']));
                    }
                  }
              })
            }
          } else {
            if(obj[key][0].isBuyer) {
              if(obj[key][0].date < selectedDateString) {
                  self.firmCashSale +=(Number.parseFloat(obj[key][0]['amountFromBank']) + Number.parseFloat(obj[key][0]['amountFromCash']));
              }
              if(this.isDateEqual(obj[key][0].date,selectedDateString)) {
                self.cashSale.invoice.push({
                  userName : self.getCustomerName(obj[key][0].buyerId,obj[key][0].isBuyer),
                  amount : (Number.parseFloat(obj[key][0]['amountFromBank']) + Number.parseFloat(obj[key][0]['amountFromCash']))
                })
                self.cashSale.total +=(Number.parseFloat(obj[key][0]['amountFromBank']) + Number.parseFloat(obj[key][0]['amountFromCash']));
              }
            } else {
              if(obj[key][0].date < selectedDateString) {
                self.firmPayment +=(Number.parseFloat(obj[key][0]['amountFromBank']) + Number.parseFloat(obj[key][0]['amountFromCash']));
              }
              if(this.isDateEqual(obj[key][0].date,selectedDateString)) {
                self.payments.invoice.push({
                  userName : self.getCustomerName(obj[key][0].buyerId,obj[key][0].isBuyer),
                  amount : (Number.parseFloat(obj[key][0]['amountFromBank']) + Number.parseFloat(obj[key][0]['amountFromCash']))
                })
                self.payments.total +=(Number.parseFloat(obj[key][0]['amountFromBank']) + Number.parseFloat(obj[key][0]['amountFromCash']));
              }
            }
          }
        }); 
      }
    }
  }
</script>
<style>
.v-data-iterator.profit .v-expansion-panel__header__icon {
  display: none;
}
.v-data-iterator.profit .v-expansion-panel__header {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/CashAccount/CashAccounts.vue